export default "__VITE_ASSET__Xb7kBsax__"